import * as React from 'react';
import * as _ from 'underscore';

import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { IServerUserInfo } from '../../../ts/models/IServerUserInfo';
import { ISiteUserInfo } from '../../../ts/models/ISiteUserInfo';
import { ProfilePictureService } from '../../../ts/services/ProfilePictureService';
import { IToastOptions, ToasterService, ToastType } from '../../../ts/services/ToasterService';
import { EditableUserProfilePicture } from '../../content/EditableUserProfilePicture';
import { ServiceLocator } from '../../ServiceLocator';

export interface SiteUserIconOwnProps {
  readonly user: IServerUserInfo | ISiteUserInfo;
  readonly isSessionUserSelf: boolean;
}

export interface SiteUserIconPropsFromAngular {
  readonly toaster: ToasterService;
  readonly profilePictureService: ProfilePictureService;
}

export type SiteUserIconProps = SiteUserIconOwnProps & SiteUserIconPropsFromAngular;

export class SiteUserIconComponent extends React.Component<SiteUserIconProps> {
  public render() {
    let imgSrc = imgPath('user_content_type.svg');
    if (_.has(this.props.user, 'userImageUrl') && this.props.user.userImageUrl) {
      imgSrc = this.props.user.userImageUrl;
    }
    const props: EditableUserProfilePicture.Props = {
      profileDisplayName: this.props.user.displayName,
      imageUrl: imgSrc,
      allowEdit: this.props.isSessionUserSelf,
      imageValidator: this.imageValidator,
      handleSubmit: this.handleSubmit
    };

    return <EditableUserProfilePicture {...props} />;
  }

  private imageValidator = (imageFile: File, handleValidationResult: (isValidImage: boolean) => void) => {
    const errorMessage: string = this.props.profilePictureService.validateImage(imageFile);
    if (errorMessage) {
      this.showToasterWarningOrReload ({
        type: ToastType.Error,
        text: errorMessage,
      });
    }
    handleValidationResult(!errorMessage);
  }

  private handleSubmit =  (newUserImage: Blob) => {
    this.props.profilePictureService.handlePictureSubmit(this.props.user.domainName, this.props.user.username,
      newUserImage, (toasterConfig: IToastOptions) => this.showToasterWarningOrReload(toasterConfig));
  }

  private showToasterWarningOrReload = (toasterConfig: IToastOptions) => {
    if (toasterConfig) {
      this.props.toaster.pop(toasterConfig);
    } else {
      window.location.reload();
    }
  }
}


export namespace SiteUserIconAngularProvider {

  function getAngularServicesWithServiceLocator() {
    const profilePictureService =  ServiceLocator.get<ProfilePictureService>('ProfilePictureService');
    const toaster = ToasterService.instance;
    return {
      profilePictureService,
      toaster
    };
  }

  function selectPropsFromAngularServices(angularServices: SiteUserIconPropsFromAngular) {
    return {
      profilePictureService: angularServices.profilePictureService,
      toaster: angularServices.toaster,
    };
  }

  export const HOC = angularProviderHOC<SiteUserIconOwnProps, SiteUserIconPropsFromAngular, SiteUserIconPropsFromAngular>({
    getAngularServicesWithServiceLocator,
    selectPropsFromAngularServices,
  });
}

export const SiteUserIcon: React.ComponentType<SiteUserIconOwnProps> = SiteUserIconAngularProvider.HOC(SiteUserIconComponent);
